const C = {
  name: "Monitoring",
  dimensions: { width: 20, height: 20 },
  content: `
    <svg fill="currentColor">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M20 3C20 1.34772 18.6523 0 17 0H3C1.34772 0 0 1.34772 0 3V17C0 18.6523 1.34772 20 3 20H17C18.6523 20 20 18.6523 20 17V3ZM2 3C2 2.45228 2.45228 2 3 2H17C17.5477 2 18 2.45228 18 3V9.00001H16.1324C15.0786 9.00001 14.1021 9.55291 13.5599 10.4565L12.1797 12.7568L8.92848 4.62862C8.78738 4.27587 8.45858 4.03355 8.07987 4.00321C7.70117 3.97286 7.33797 4.15974 7.14251 4.48552L4.72511 8.51451C4.54439 8.81571 4.21888 9.00001 3.86762 9.00001H2V3ZM2 11H3.86762C4.92141 11 5.89793 10.4471 6.4401 9.5435L7.82026 7.24323L11.0715 15.3714C11.2126 15.7241 11.5414 15.9665 11.9201 15.9968C12.2988 16.0272 12.662 15.8403 12.8575 15.5145L15.2749 11.4855C15.4556 11.1843 15.7811 11 16.1324 11H18V17C18 17.5477 17.5477 18 17 18H3C2.45228 18 2 17.5477 2 17V11Z"/>
    </svg>
  `
};
export {
  C as Monitoring
};
